import React from 'react';

const FinanceDashboard = ({ activeTab = 'overview' }) => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Finance Dashboard</h1>
      <p>Active Tab: {activeTab}</p>
      <p>Finance management features coming soon...</p>
    </div>
  );
};

export default FinanceDashboard;
